import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const MySitesLayout = lazy(() => import("@/pages/mina-sidor/MySitesLayout"));

export const Route = createFileRoute("/mina-sidor")({
  head: () => ({
    meta: [
      { title: "Mina sidor | Elmarknad.se" },
      { name: "description", content: "Hantera dina elavtal, anläggningar, fullmakter och rapporter på Mina sidor hos Elmarknad.se." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: () => <MySitesLayout />,
});
